export const Apinames = {
  login: "/users/login",
  signUp: "/users/signup",
  usersGoogleSignup:"/users/googleSignup",
  usersGoogleSignin: "/users/googleSignin",
  signUpSendOtp: "/users/sendOtp",
  forgotPasswordSendOtp: "/forgotPassword/sendOtp",
  forgotPasswordVerifyOtp: "/forgotPassword/verifyOtp",
  forgotPasswordUpdatePassword: "/forgotPassword/updatePassword",
  notificationAll: "/notification/all",
  notificationRead: "/notification/read",
  usersUpdate:"/users/update",

  // user
  usersAll: "/users/all",
  usersupdateStatus: "/users/updateStatus",
  usersStats: "/users/stats",
  companyEmployees:"/users/companyEmployees",
  //billing
  billingGetBills: "/billing/getBills",
  payBill: "/billing/pay",
  usersGetSubscriptions: "/users/getSubscriptions",
  UpdateUserSubscription: "/users/updateUserSubscription",

  //lov
  lovDepartments: "/lov/departments",

  usersAddEmployee: "/users/addEmployee",
  // checklist
  checklistAdd: "/checklist/add",
  checklistUpdate: "/checklist/update",
  checklistAll: "/checklist/all",
  checklistResponses: "/checklist/responses",
  checklistQuestions: "/checklist/questions",
  checklistDelete: "/checklist/delete",

  // QualiCheck AI
  permissionsMe: "/permissions/me",
  userPermissions: (userId: number) => `/users/${userId}/permissions`,
  sites: "/sites",
  site: (id: number) => `/sites/${id}`,
  lovProcesses: "/lov/processes",
  lovOperationalAreas: "/lov/operational-areas",
  lovAdd: (type: "PROCESS" | "OPERATIONAL_AREA") => `/lov/${type}`,
  lovItem: (id: number) => `/lov/item/${id}`,
  analysisMetadata: (checklistId: number) => `/checklist/${checklistId}/analysis-metadata`,
  preAnalysis: (checklistId: number) => `/ai/checklists/${checklistId}/pre-analysis`,
  analyses: "/ai/analyses",
  analysis: (id: number) => `/ai/analyses/${id}`,
  analysisRetry: (id: number) => `/ai/analyses/${id}/retry`,
  analysisRegenerate: (id: number) => `/ai/analyses/${id}/regenerate`,
  analysisReports: (id: number) => `/ai/analyses/${id}/reports`,
  aiSettings: "/ai/settings",
  findings: "/findings",
  finding: (id: number) => `/findings/${id}`,
  findingTransition: (id: number) => `/findings/${id}/transition`,
  findingComments: (id: number) => `/findings/${id}/comments`,
  capas: "/capas",
  capa: (id: number) => `/capas/${id}`,
  capaTransition: (id: number) => `/capas/${id}/transition`,
  capaRootCause: (id: number) => `/capas/${id}/validate-root-cause`,
  capaEvidence: (id: number) => `/capas/${id}/evidence`,
  file: (id: number) => `/files/${id}`,
  auditEntity: "/audit/entity",
  audit: "/audit",
  auditExport: "/audit/export",
  acesActive: "/aces/active",
  acesEditions: "/aces/editions",
  acesEdition: (id: number) => `/aces/editions/${id}`,
  acesEditionStatus: (id: number) => `/aces/editions/${id}/status`,
  acesImport: (id: number) => `/aces/editions/${id}/import`,
  acesExport: (id: number) => `/aces/editions/${id}/export`,
  acesClause: (id: number) => `/aces/clauses/${id}`,
  tenantAiSettings: "/admin/tenants/ai-settings",
  tenantAiSetting: (tenantId: number) => `/admin/tenants/${tenantId}/ai-settings`,
};
